import React from 'react';
import {
  HStack,
  Text,
  Icon,
  CloseButton,
  Flex,
  VStack,
  Button,
} from '@wegroup/design-system';

interface ActionLinkToastProps {
  actionUrl: string;
  onClose: () => void;
  title: string;
  description: string;
  copyButtonText: string;
}

const ActionLinkToast = ({
  actionUrl,
  onClose,
  title,
  description,
  copyButtonText,
}: ActionLinkToastProps) => {
  const [isCopied, setIsCopied] = React.useState(false);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <HStack
      ml="3"
      mb="3"
      p="4"
      boxShadow="level3"
      bg="green.500"
      borderRadius="md"
      spacing="8"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        w="5"
        h="5"
        bg="white"
        borderRadius="full"
      >
        <Icon name="IconStatusCheck" color="green.500" />
      </Flex>
      <VStack spacing="2" align="flex-start" flex={1}>
        <HStack
          justifyContent="space-between"
          alignItems="center"
          spacing="2"
          w="100%"
        >
          <Text textStyle="smallBodyMedium" color="white">
            {title}
          </Text>
          <CloseButton onClick={onClose} color="white" />
        </HStack>
        <Text textStyle="smallBody" color="white" pb={2}>
          {description}
        </Text>
        <Button
          onClick={() => copyToClipboard(actionUrl)}
          variant="outline"
          size="sm"
          color="white"
          borderColor="white"
          leftIcon={
            <Icon
              boxSize={4}
              name={
                isCopied
                  ? 'GeneralStatusSuccessCheckmark'
                  : 'GeneralActionsDuplicate'
              }
            />
          }
          _hover={{
            bg: 'white',
            color: 'green.500',
            borderColor: 'white',
            '& svg': {
              color: 'green.500',
            },
          }}
        >
          {copyButtonText}
        </Button>
      </VStack>
    </HStack>
  );
};

export default ActionLinkToast;
